import { render, staticRenderFns } from "./PanelDataSettings.vue?vue&type=template&id=17c702f0&"
import script from "./PanelDataSettings.vue?vue&type=script&lang=js&"
export * from "./PanelDataSettings.vue?vue&type=script&lang=js&"
import style0 from "./PanelDataSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports